import styled from 'styled-components';

export const ModalTopContainer = styled.div`
  width: 387px;
  height: 195px;
  border-radius: 25px 25px 0 25px;
  font-family: 'MaruBuri-Regular';
  background-color: #f9f9f6;
  color: #1d1c1c;
  font-size: 14px;
  line-height: 1.7;
`;

export const ModalBottomContainer = styled.div`
  width: 387px;
  height: 70px;
  border-radius: 25px 25px 0 25px;
  background-color: rgba(234, 233, 227, 1);
`;

export const BigRed = styled.div`
  font-size: 18px;
  font-weight: 700;
  font-family: 'MaruBuri-Regular';
  line-height: 1.4;
  color: #ff6058;
  padding-top: 25px;
  padding-left: 40px;
  margin-bottom: 10px;
`;

export const OpenChat = styled.div`
  width: 307px;
  height: 46px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 700;
  font-family: 'MaruBuri-Regular';
  color: #575655;
  border: 1px solid #575655;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 40px;
`;

export const ALink = styled.a`
  font-size: 14px;
  font-weight: 700;
  font-family: 'MaruBuri-Regular';
  color: #575655;
  text-decoration: none;
`;

export const DIV = styled.div`
  padding-left: 40px;
  margin-bottom: 15px;
`;

export const Infom = styled.div`
  padding-left: 40px;
  color: #81807f;
  font-size: 20px;
  font-weight: 700;
  font-family: 'MaruBuri-Regular';
  line-height: 1.4;
  padding-top: 20px;
  display: flex;
  align-items: center;
`;
